export default __webpack_public_path__ + "static/media/1.bcf9b4c1.jpg";